import { configuration as defaultV2Configuration } from '../configurations/default_v2';
import { configuration as defaultV3Configuration } from '../configurations/default_v3';
import { configuration as defaultV4Configuration } from '../configurations/default_v4';
import { configuration as safecasinoV2Configuration } from '../configurations/safecasino_v2';

import { PlatformConfiguration } from '../model';

type Version = 'v2' | 'v3' | 'v4';
const CONFIGURATION_MAP: Record<string, PlatformConfiguration> = {
  v2: defaultV2Configuration,
  v3: defaultV3Configuration,
  v4: defaultV4Configuration,
  // We have some weird mixed v2/v3 styles for safecasino v2 cashier
  safecasino_v2: safecasinoV2Configuration,
};

interface PlatformConfigurationRegistry {
  get(name: string, version: Version): PlatformConfiguration;
  getDefault(version: Version): PlatformConfiguration;
}

export const platformConfigurationRegistry: PlatformConfigurationRegistry = {
  get: (name: string, version: Version): PlatformConfiguration => {
    return (
      CONFIGURATION_MAP[`${name}_${version}`] || CONFIGURATION_MAP[version]
    );
  },

  getDefault: (version: Version): PlatformConfiguration => {
    return CONFIGURATION_MAP[version];
  },
};
